<template>
  <div>
    <div v-show="isShow" class="list-group-item list-group-item-action border-bottom p-0">
      <div class="px-3 py-3" :class="isRead ? 'bg-dark' : ''" @click="toViewer(this.row)">
        <div class="d-flex justify-content-between">
          <h3 class="fs-5"><i :class="isRead ? 'cil-speech pe-2' : 'cil-speech pe-2'"></i>{{ row.sent_by }}</h3>
          <span>{{ $moment(row.created_at).locale('ja').format('l(ddd)HH:mm') }}</span>
        </div>
        <div class="text-truncate">
          <span>[発行依頼ID:{{ row.issuance_request_id }}] </span>
          <span>{{ row.message }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
  name: "NotificationTalkAreaData",
  provide: {
    bindModule: 'talk_notifieds'
  },
  inject: [
    '$moment',
  ],
  props: {
    unreadChecked: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isShow() {
      if (this.unreadChecked) {
        return !this.row.is_read;
      } else {
        return true;
      }
    },
    isRead() {
      return this.row.is_read;
    },
  },
  methods: {
    ...mapMutations('talk_notifieds', [
      'setShowNotificationList',
    ]),
    toViewer(row) {
      const talkContainer = document.querySelector('#talk-button-actived');
      if (talkContainer) {
        talkContainer.click();
      }
      const notificationTalkButton = document.querySelector('#notification-talk-button');
      if (notificationTalkButton) {
        notificationTalkButton.click();
      }
      this.setShowNotificationList({ value: false });

      let routeName = row.is_requester ? "IssuanceRequestOwnViewer" : "IssuanceRequestViewer";
      this.$router.push({ name: routeName, params: { id: row.issuance_request_id }, hash: "#talk" });
    },
  },
}
</script>